// extracted by mini-css-extract-plugin
export default {"take":"take--mIfwi"};